"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = require("prop-types");

var _Input = _interopRequireDefault(require("../Input"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tmargin-bottom: 0px !important;\n\t\t\tborder-bottom-left-radius: 0px;\n\t\t\tborder-color: ", " !important;\n\t\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-right: 0 !important;\n\tborder-bottom-right-radius: 0;\n\tborder-top-right-radius: 0;\n\tpadding-right: ", ";\n\twidth: 90px !important;\n\tposition: relative;\n\tz-index: 2;\n\tbox-shadow: none;\n\n\t", ";\n\n\t&:focus {\n\t\tbox-shadow: none;\n\t\tborder-color: ", " !important;\n\t}\n\n\t&:focus + ", " {\n\t\tborder-color: ", " !important;\n\t}\n\n\t&:disabled + ", " {\n\t\tcolor: ", ";\n\t\tborder-color: ", " !important;\n\t\tbackground-color: ", ";\n\t}\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tmargin-bottom: 0px !important;\n\t\t\tborder-bottom-right-radius: 0px;\n\t\t\tborder-color: ", " !important;\n\t\t"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-left: 0 !important;\n\tborder-bottom-left-radius: 0;\n\tborder-top-left-radius: 0;\n\tpadding-left: 0;\n\tdisplay: inline-block;\n\tcolor: ", ";\n\twidth: auto !important;\n\tline-height: 2.5rem !important;\n\t", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Label = _styledComponents.default.label(_templateObject());

Label.displayName = 'Label';
var Unit = (0, _styledComponents.default)(_Input.default.withComponent('span'))(_templateObject2(), _colors.default.borderColor, function (props) {
  return props.invalid && (0, _styledComponents.css)(_templateObject3(), _colors.default.borderError);
});
Unit.displayName = 'Unit';
var InnerInput = (0, _styledComponents.default)(_Input.default)(_templateObject4(), _spacing.default.s1, function (props) {
  return props.invalid && (0, _styledComponents.css)(_templateObject5(), _colors.default.borderError);
}, function (props) {
  return props.invalid ? _colors.default.borderError : _colors.default.borderFocus;
}, Unit, function (props) {
  return props.invalid ? _colors.default.borderError : _colors.default.borderFocus;
}, Unit, _colors.default.disabled, _colors.default.disabledOutline, _colors.default.disabledBackground);
InnerInput.displayName = 'InnerInput';

var InputWithUnit = function InputWithUnit(_ref) {
  var unit = _ref.unit,
      className = _ref.className,
      gaAction = _ref.gaAction,
      gaTrackValue = _ref.gaTrackValue,
      invalid = _ref.invalid,
      props = _objectWithoutPropertiesLoose(_ref, ["unit", "className", "gaAction", "gaTrackValue", "invalid"]);

  return _react.default.createElement(Label, {
    className: className,
    "data-testid": "label"
  }, _react.default.createElement(InnerInput, _extends({
    invalid: invalid,
    "data-track-action": gaAction,
    "data-track-value": gaTrackValue ? 'on' : 'off'
  }, props)), _react.default.createElement(Unit, {
    invalid: invalid
  }, unit));
};

InputWithUnit.displayName = 'InputWithUnit';
InputWithUnit.propTypes = {
  className: _propTypes.string,
  unit: _propTypes.string.isRequired,
  gaAction: _propTypes.string,
  gaTrackValue: _propTypes.bool,
  invalid: _propTypes.bool
};
InputWithUnit.defaultProps = {
  gaAction: '',
  className: '',
  gaTrackValue: false,
  invalid: false
};
var _default = InputWithUnit;
exports.default = _default;